var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_like",
    "data-name": "vuesax/outline/like",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_like-2",
    "data-name": "vuesax/outline/like"
  }, /*#__PURE__*/React.createElement("g", {
    id: "like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.025,25.253a4.773,4.773,0,0,1-3.037-1.025L.2,21.3l1.15-1.487,3.875,3a2.99,2.99,0,0,0,1.8.55h4.75a2.835,2.835,0,0,0,2.588-1.913l3.025-9.187a1.489,1.489,0,0,0-.1-1.413A1.646,1.646,0,0,0,15.9,10.24h-5a2.189,2.189,0,0,1-1.662-.75,2.23,2.23,0,0,1-.512-1.812L9.35,3.665a1.556,1.556,0,0,0-1-1.712,1.59,1.59,0,0,0-1.675.5L1.55,10.078,0,9.04,5.125,1.415A3.385,3.385,0,0,1,11.2,4.028l-.613,3.938a.38.38,0,0,0,.075.313.349.349,0,0,0,.25.1h5a3.479,3.479,0,0,1,2.912,1.4,3.331,3.331,0,0,1,.337,3.1l-2.988,9.1a4.659,4.659,0,0,1-4.4,3.275Z",
    transform: "translate(8.574 2.372)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.688,18.875H3.438C1.125,18.875,0,17.792,0,15.562V3.312C0,1.083,1.125,0,3.438,0h1.25C7,0,8.125,1.083,8.125,3.312v12.25C8.125,17.792,7,18.875,4.688,18.875Zm-1.25-17c-1.358,0-1.563.324-1.563,1.437v12.25C1.875,16.676,2.08,17,3.438,17h1.25c1.358,0,1.563-.324,1.563-1.438V3.312c0-1.113-.205-1.437-1.563-1.437Z",
    transform: "translate(2.039 7.375)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M30,0V30H0V0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo1);
export default __webpack_public_path__ + "static/media/co1.6b54b4fc65757f140ffbc01bbcf555b3.svg";
export { ForwardRef as ReactComponent };